module.exports = __webpack_public_path__ + "img/calendarXFill.3e150293.svg";